<template>
  <div class="tw:flex tw:gap-4">
    <!-- Always reserve the visual column, so rows stay aligned whether or not there is an image. -->
    <div class="tw:flex-none">
      <img
        v-if="item.product.image && noImage === false"
        :onerror="() => {noImage = true}"
        :src="item.product.image"
        :alt="item.product.name"
        class="tw:w-12"
      />
      <Package v-else stroke-width="1" class="tw:size-12 tw:text-zinc-500" />
    </div>

    <div class="tw:flex-1">
      <div v-if="item.product" class="tw:inline-flex tw:items-center tw:gap-1">
        <h3 class="tw:text-base tw:m-0">
          {{ item.product.name }}
        </h3>
        <div v-if="item.product.links.show">
          <a
            :href="item.product.links.show"
            target="_blank"
            class="tw:text-blue-600 p-1 rounded tw:hover:bg-zinc-100 tw:inline-flex tw:items-center tw:gap-1"
          >
            <span class="tw:sr-only">{{ $t("Edit") }}</span>
            <SquareArrowOutUpRight class="tw:size-3" />
          </a>
        </div>
      </div>
      <div v-if="item.product && item.product.brand" class="tw:text-zinc-500">
        {{ item.product.brand.name }} -
        {{ item.product.category }}
      </div>

      <div class="mb-0 tw:text-zinc-500" v-if="item">
        <div v-if="item.size || item.color">
          <template v-if="item && item.size">
            {{ $t("Size") }} : {{ item.size }}
          </template>
          <template v-if="item.size && item.color"> - </template>
          <template v-if="item && item.color">
            {{ $t("Color") }} : {{ item.color }}
          </template>
        </div>

        <div class="tw:flex tw:items-center tw:gap-1">
          <div
            v-if="item.barcode_number"
            class="tw:flex tw:items-center tw:gap-1.5"
          >
            <QrCode class="tw:size-4" />
            <code>{{ item.barcode_number }}</code>
          </div>
          <div v-else class="text-muted">
            {{ $t("No Barcode") }}
          </div>
          <div v-if="item.links.edit">
            <a
              :href="item.links.edit"
              target="_blank"
              class="tw:text-blue-600 p-1 rounded tw:hover:bg-zinc-100 tw:inline-flex tw:items-center tw:gap-1"
            >
              <span class="tw:sr-only">{{ $t("Edit") }}</span>
              <SquareArrowOutUpRight class="tw:size-3" />
            </a>
          </div>
        </div>

        <template v-if="item.deleted_at">
          <div class="badge badge-danger tw:inline-flex tw:flex-none tw:items-center tw:gap-1">
            <Trash2 class="tw:size-3" />
            <div>{{ $t("Item deleted") }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Package, QrCode, SquareArrowOutUpRight, Trash2 } from "@lucide/vue";
import { ref } from "vue";

const noImage = ref(false);

defineProps<{
  item: object;
}>();
</script>
